var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8328 5.8333H3.97417L7.82577 1.99813C8.04555 1.77862 8.16902 1.48091 8.16902 1.17048C8.16902 0.860046 8.04555 0.562331 7.82577 0.342824C7.60599 0.123318 7.3079 0 6.99709 0C6.68628 0 6.38819 0.123318 6.16841 0.342824L0.332654 6.17135C0.226396 6.28222 0.143102 6.41294 0.0875521 6.55604C-0.0291841 6.83984 -0.0291841 7.15817 0.0875521 7.44197C0.143102 7.58507 0.226396 7.71579 0.332654 7.82666L6.16841 13.6552C6.27691 13.7644 6.406 13.8512 6.54823 13.9103C6.69046 13.9695 6.84301 14 6.99709 14C7.15117 14 7.30372 13.9695 7.44595 13.9103C7.58818 13.8512 7.71727 13.7644 7.82577 13.6552C7.93516 13.5468 8.02199 13.4179 8.08125 13.2758C8.1405 13.1338 8.17101 12.9814 8.17101 12.8275C8.17101 12.6736 8.1405 12.5213 8.08125 12.3792C8.02199 12.2372 7.93516 12.1083 7.82577 11.9999L3.97417 8.16471H12.8328C13.1424 8.16471 13.4393 8.0419 13.6581 7.82328C13.877 7.60467 14 7.30817 14 6.99901C14 6.68984 13.877 6.39334 13.6581 6.17473C13.4393 5.95611 13.1424 5.8333 12.8328 5.8333Z",
    fill: "#082980"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow_left.baff038cda1a4465af26bd024bb10c20.svg";
export { ForwardRef as ReactComponent };